import React from "react";
import { LinkInfo } from "../models/shared/LinkInfo";
import { isNullOrWhiteSpace } from "../shared/string";
import { isValidLink } from "../utilities/links";
import Button, { ButtonSize } from "./Buttons/Button";
import PortableText, { PortableTextBody } from "./PortableText";
import { PortableTextColorTheme } from "./PortableText/PortableText";
import { renderLinkTitle } from "./SanityLink";

export interface DualLinkBlockProps {
  _rawPortableTextContent?: PortableTextBody;
  portableTextContent?: PortableTextBody;
  primaryButton?: LinkInfo;
  secondaryButton?: LinkInfo;
  title?: string;
}

export const DualLinkBlock = ({
  _rawPortableTextContent,
  portableTextContent,
  primaryButton,
  secondaryButton,
  title
}: DualLinkBlockProps) => (
  <aside className="max-w-4xl mx-auto">
    {!isNullOrWhiteSpace(title) && (
      <>
        <h2 className="mb-5">{title}</h2>
        <hr className="h-divider-thick w-16 mb-5 bg-current" />
      </>
    )}
    {(_rawPortableTextContent || portableTextContent) && (
      <PortableText
        _rawBody={_rawPortableTextContent ?? portableTextContent}
        addSections={false}
        colorTheme={PortableTextColorTheme.Neutral}
      />
    )}
    {(isValidLink(primaryButton) || isValidLink(secondaryButton)) && (
      <div className="mt-8 flex flex-col gap-4 sm:flex-row sm:flex-wrap">
        {isValidLink(primaryButton) && (
          <Button
            className="text-center"
            color="primary"
            size={ButtonSize.Normal}
            type={"link"}
            {...primaryButton}
          >
            {renderLinkTitle(primaryButton)}
          </Button>
        )}
        {isValidLink(secondaryButton) && (
          <Button
            className="text-center"
            color="primary-inverted"
            size={ButtonSize.Normal}
            type={"link"}
            {...secondaryButton}
          >
            {renderLinkTitle(secondaryButton)}
          </Button>
        )}
      </div>
    )}
  </aside>
);

